import { Box, Grid, Link, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { AxiosHttpClient } from "../../../services/AxiosHttpService";
import { AppName } from "../../../styles/AppName";
import { ButtonMui } from "../../../styles/ButtonMui";
import { FlexContainer } from "../../../styles/FlexContainer";
import { Text16 } from "../../../styles/Text";
import { ThemeCustom } from "../../../styles/Utils";

export const ForgotPasswordForm: React.FC = () => {
  const [forgotPasswordActive, setForgotPasswordActive] = useState(true);
  const [emailSentAlert, setEmailSentAlert] = useState(false);
  const [inputEmail, SetInputEmail] = useState("");

  const setUserPassword = () => {
    AxiosHttpClient.putForNonAuth(
      "api/v1/docuveritas/users/sendPasswordResetEmail",
      {
        email: inputEmail,
      }
    )
      .then(() => {
        setForgotPasswordActive(false);
        setEmailSentAlert(true);
      })
      .catch((err) => {
        setForgotPasswordActive(false);
        setEmailSentAlert(true);
      });
  };

  return (
    <FlexContainer flex="1" elevation={5} backgroundColor="white">
      <FlexContainer
        flexDirection="column"
        margin="64px 32px"
        textAlign="left"
        width="100%"
      >
        <FlexContainer margin="20px" alignSelf="center">
          <AppName color={ThemeCustom.colors.pink}>We</AppName>
          <AppName color={ThemeCustom.colors.orange}>Event</AppName>
        </FlexContainer>

        <Text16>
          Veuillez spécifier votre adresse email. Nous vous enverrons un mail
          pour réinitialiser votre mot de passe.
        </Text16>

        <Grid
          container
          spacing={{ xs: 1, sm: 1, md: 2 }}
          columns={{ xs: 1, sm: 1, md: 2 }}
        >
          <Grid item xs={1} sm={1} md={2}>
            <TextField
              value={inputEmail}
              onChange={(e) => SetInputEmail(e.target.value)}
              label="Email"
              variant="outlined"
              fullWidth
              margin="normal"
              required
            />
          </Grid>
        </Grid>
        <FlexContainer margin="24px 0 16px" justifyContent={"center"}>
          <ButtonMui
            color="primary"
            variant="contained"
            size="large"
            onClick={() => {
              setUserPassword();
            }}
          >
            CONFIRMER
          </ButtonMui>
          <ButtonMui
            color="primary"
            variant="outlined"
            size="large"
            margin="0 0 0 8px"
            onClick={() => setForgotPasswordActive(false)}
          >
            RETOUR
          </ButtonMui>
        </FlexContainer>
        <Box mt={8}>
          <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="/">
              Docuveritas
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
          </Typography>
        </Box>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ForgotPasswordForm;
